import type { LinkStatus, UserRole, UserTier } from "../../shared/types";

export const statusLabels: Record<LinkStatus, string> = {
  active: "生效",
  pending: "待审",
  rejected: "已拒绝",
  grace: "宽限期",
  released: "已释放",
  disabled: "已停用",
};

export const roleLabels: Record<UserRole, string> = {
  super_admin: "超管",
  admin: "管理员",
  user: "用户",
};

export function accountRoleLabel(role: UserRole, tier: UserTier): string {
  return role === "user" && tier === "vip" ? "VIP" : roleLabels[role];
}

export function number(value: number): string {
  return new Intl.NumberFormat("zh-CN").format(value);
}

export function date(value: string | null, includeTime = false): string {
  if (!value) return "—";
  return new Intl.DateTimeFormat("zh-CN", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    ...(includeTime ? { hour: "2-digit", minute: "2-digit" } : {}),
  }).format(new Date(value));
}

export function relative(value: string | null): string {
  if (!value) return "永不过期";
  const diff = new Date(value).getTime() - Date.now();
  const days = Math.ceil(Math.abs(diff) / 86_400_000);
  if (Math.abs(diff) < 60_000) return diff >= 0 ? "即将到期" : "刚刚到期";
  return diff >= 0 ? `${days} 天后` : `${days} 天前`;
}

export function host(value: string): string {
  try {
    return new URL(value).hostname;
  } catch {
    return value;
  }
}
